// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-restaurant-information,.h-theme--lucy .h-restaurant-information td{width:100%}.h-restaurant-information__wrap{display:-webkit-box;display:-ms-flexbox;display:flex}.h-restaurant-information__wrap__text{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.h-restaurant-information__wrap__supplement{-webkit-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;margin-left:1em}", ""]);
// Exports
module.exports = exports;
